import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"
import DrawerCom from "./DrawerCom"

import BaseBtnCom from "../BaseBtnCom"
import { CancelTextBtnWrap, DrawerWinOneTileWrap, DrawerWinTwoTileWrap, PaddingLeftRightWrap } from "./DrawerStyle"
import WarnBarCom from "components/WarnBarCom"
import { useCallback, useEffect, useState } from "react"

interface Props {
    open: boolean
    closeChange?: (isOpen: boolean) => void
    onComplete?: (obj?: any) => void
}

const DrawerSlippageCom = ({open, closeChange = (isOpen) => {}, onComplete = (obj) => {}}: Props) => {

    /**
     * 资源初始化
     */
    const fnInit = useCallback(() => {
        if(open) {
            // 初始化资源

        } else {
            // 清理资源

        }
    }, [open])

    useEffect(() => {
        fnInit()
    }, [fnInit])

    /**
     * 关闭回调
     */
    const [closeRandom, setCloseRandom] = useState(0)
    const fnClosed = (closed: boolean) => {
        closeChange(closed)
        setCloseRandom(0)
    }
    const fnCloseWin = useCallback(() => {
        setCloseRandom(closeRandom + 1)
    }, [closeRandom])

    /**
     * 完成回调
     */
    const fnConfirm = () => {
        onComplete();
        fnCloseWin()
    }

    return open ? <DrawerCom isOpen={open} closeRandom={closeRandom} onClose={fnClosed}>
        <DrawerContentWrap $isError={true}>
            <PaddingLeftRightWrap>
                <DrawerWinOneTileWrap>High slippage warning</DrawerWinOneTileWrap>
                <DrawerWinTwoTileWrap $mb="20px">The slippage for this swap is around 20%.</DrawerWinTwoTileWrap>

                <WarnBarCom isError={true} desc="Proceeding implies you accept the inherent 20% slippage"></WarnBarCom>
                <StyledContainer $height="50px"></StyledContainer>

                <StyledContainer $fontSize="14px" $fontWeight6 $lineHeight="16px" $roobertSemiBold>Are you sure you want to continue?</StyledContainer>
                <StyledContainer $height="20px"></StyledContainer>

                <BaseBtnCom type="1" title="Swap now" onClick={fnConfirm}></BaseBtnCom>

                <CancelTextBtnWrap onClick={() => setCloseRandom(closeRandom + 1)}>Cancel</CancelTextBtnWrap>
            </PaddingLeftRightWrap>
        </DrawerContentWrap>
    </DrawerCom> : <></>
}

const DrawerContentWrap = styled(StyledContainer)<{$isError: boolean}>`
    ${
        ({$isError, theme}) => $isError ? css`
         
        ` : css`
        `
    }
`

export default DrawerSlippageCom